import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import BackgroundPicker from '../../../widgets/BackgroundPicker';

class HeaderGeneral extends Component {
    render() {
        return (
            <div className="HeaderGeneral">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12">
                        <BackgroundPicker
                            background={this.props.userBar.background}
                            preset={this.props.themeColors.primary.colors}
                            isDisabled={this.props.isDisabled}
                            onChange={property =>
                                this.props.onThemePropChange('background')({
                                    target: {
                                        value: property
                                    }
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

HeaderGeneral.propTypes = {
    tagNameName: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {
    return { ...state.app.data.theme.header, ...state.theme.header, themeColors: state.app.data.theme.colors };
};

const mapDispatchToProps = dispatch => {
    return {
        onThemePropChange: onThemePropChange(dispatch, 'header.userBar')
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderGeneral);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/General.js